/**
 * Percent share of each default path by weight (Voluum-style list).
 * Only **active** paths participate in the 100% split; inactive paths show 0%.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { VoluumPathUpdate } from '@trafficpulse/shared';

function weightValue(p: VoluumPathUpdate): number {
  return Math.max(0, Number(p.weight) || 0);
}

/** Share among default paths: only **active** paths count toward 100%; inactive show 0%. */
export function defaultPathWeightPercents(paths: VoluumPathUpdate[]): number[] {
  const sumActive = paths.reduce(
    (s, p) => s + (p.active ? weightValue(p) : 0),
    0,
  );
  if (sumActive <= 0) return paths.map(() => 0);
  return paths.map((p) =>
    p.active ? (weightValue(p) / sumActive) * 100 : 0,
  );
}
